/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Org_Contract_SeatsInputs */



/**
* | output |
* | --- |
* | "{count} seats, billed flat" |
*
* @param {Partner_Org_Contract_SeatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_seats = /** @type {((inputs: Partner_Org_Contract_SeatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_SeatsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Plätze, pauschal abgerechnet`)
	return /** @type {LocalizedString} */ (`${i?.count} seats, billed flat`)
});